export const LINE_AMOUNT_SM = 2

export const LINE_AMOUNT_LG = 3

export const CONTENT_LOADER_AMOUNT = 5

export const ERROR_CONTENT_LOADER_AMOUNT = 6
